// extracted by mini-css-extract-plugin
module.exports = {"successTitle":"_1yQBkar9xadWxE9vRcFiA4"};